import React from 'react'
import { RouteObject } from 'react-router-dom'

import routePath from './routePath'
import { Layout } from '../layouts'
import { EmailVerification } from '../views/Register/EmailVerification'
import { LogoutView } from '../views/Logout/LogoutView'
import { FtnCallbackError } from '../views/Register/FtnCallbackError'

import { ForgotPassword } from 'views/Password/Forgot'
import { Login } from 'views/Login'
import { Register } from 'views/Register'
import { RegisterAuth } from 'views/Register/Auth'
import { InvitationRegistration } from 'views/Invitation/InvitationRegistration'

export const publicRoutes = {
  element: <Layout variant="public" />,
  children: [
    {
      id: 'loginRoute',
      path: routePath.login,
      element: <Login />,
    },
    {
      id: 'logoutRoute',
      path: routePath.logout,
      element: <LogoutView />,
    },
    {
      id: 'registerAuthRoute',
      path: routePath.registerAuth,
      element: <RegisterAuth />,
    },
    {
      id: 'forgotPasswordRoute',
      path: routePath.forgotPassword,
      element: <ForgotPassword />,
    },
    {
      id: 'registerRoute',
      path: routePath.register,
      element: <Register />,
    },
    {
      id: 'registerFtnCallbackErrorRoute',
      path: routePath.registerFtnCallbackError,
      element: <FtnCallbackError />,
    },
    {
      id: 'verifyEmailRoute',
      path: routePath.verifyEmail,
      element: <EmailVerification />,
    },
    {
      id: 'invitationRoute',
      path: routePath.invitation,
      element: <InvitationRegistration />,
    },
  ],
} as const satisfies RouteObject
